import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-19eda5d0")

_pushScopeId("data-v-19eda5d0")
const _hoisted_1 = { class: "onetrip-page" }
const _hoisted_2 = { class: "container noflex" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "noPage" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" На главную ")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SubHeader = _resolveComponent("SubHeader")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_SubHeader, {
      title: "404",
      canCreate: false,
      subText: "Такой страницы нет"
    }),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, {
        to: '/',
        class: "backLink"
      }, {
        default: _withId(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ]))
})